import script from "./InfoCell.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCell.vue?vue&type=script&setup=true&lang=js"

import "./InfoCell.vue?vue&type=style&index=0&id=dadd2a64&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dadd2a64"]])

export default __exports__